@for (item of vaps; track item) {
  <div class="form-check" style="margin-left:10px">
    <label class="form-check-label" [for]="item?.session_item_id">
      <input type="checkbox"
        [id]="item?.session_item_id"
        [name]="item?.session_item_id"
        (click)="set(item?.value, item?.session_item_id)"
        [class]="'form-check-input form-control checkboxes answers ' + question?.cent_aq_question_id"
        [value]="item?.value" required>
        <span class="checkmarkB"></span>
        <span class="checkLabel">{{item?.description}}</span>
      </label>
    </div>
  }
